'use strict';

export default class SearchListing {
  constructor() {

  }
}
